/** Status pill for a post-completion item. */
import { Badge } from "@/components/ui/badge";

const MAP = {
  not_started: ["bg-slate-100 text-slate-700", "Not started"],
  in_progress: ["bg-blue-100 text-blue-700", "In progress"],
  submitted: ["bg-amber-100 text-amber-700", "Submitted"],
  requisition: ["bg-orange-100 text-orange-800", "Requisition"],
  completed: ["bg-emerald-100 text-emerald-700", "Completed"],
  rejected: ["bg-rose-100 text-rose-700", "Rejected"],
};

export default function StatusPill({ status }) {
  const [cls, label] = MAP[status] || MAP.not_started;
  return (
    <Badge className={`${cls} hover:${cls.split(" ")[0]} border-0`} data-testid={`pc-status-pill-${status}`}>
      {label}
    </Badge>
  );
}
